// extracted by mini-css-extract-plugin
module.exports = {"permissionIcon":"ManageUsersTable_permissionIcon__3ilgu","userIcon":"ManageUsersTable_userIcon__mk31s","adminIcon":"ManageUsersTable_adminIcon__3gvVf"};